import * as amplitude from "@amplitude/analytics-browser";
import { plugin as engagementPlugin } from "@amplitude/engagement-browser";

import { v4 } from "uuid";
import i18n from "i18next";

/**
 * Initialize Amplitude Analytics
 */
export const initializeAmplitude = (): void => {
  const AMPLITUDE_API_KEY = process.env.REACT_APP_AMPLITUDE_KEY ?? null;
  if (AMPLITUDE_API_KEY) {
    // Create a one-time key to track this specific browser.
    let deviceId = localStorage.getItem("AMPLITUDE_DEVICEID");
    if (!deviceId) {
      deviceId = v4();
      localStorage.setItem("AMPLITUDE_DEVICEID", deviceId);
    }

    // Start tracking
    amplitude.init(AMPLITUDE_API_KEY, undefined, {
      appVersion: process.env.REACT_APP_VERSION ?? "unknown",
      logLevel: amplitude.Types.LogLevel.Warn,
      deviceId,
    });
    const locale = i18n.language ?? navigator.language ?? "en-GB";
    amplitude.add(engagementPlugin({ locale }));
    i18n.on("languageChanged", (lng: string): void => {
      const updateLanguagePromise = (
        globalThis as any
      ).engagement?.updateLanguage(lng);

      if (!updateLanguagePromise) {
        return;
      }

      updateLanguagePromise.catch((error: unknown): void => {
        console.error("Failed to update engagement language:", error);
      });
    });
  }
};

/**
 * Clears user identity information from Amplitude while keeping event tracking enabled.
 * Use this when a user revokes cookie consent and you must stop associating events to a known user.
 */
export const resetAmplitudeUserIdentity = (): void => {
  try {
    // Resets user_id and user properties; tracking continues anonymously.
    amplitude.reset();
  } catch (error) {
    console.error("Failed to reset Amplitude user identity:", error);
  }
};
